import React from 'react'
// import moment from 'moment'
import { fromNullable } from 'data.maybe'
import styled from 'styled-components'
import { DatePicker } from 'antd'
// const { MonthPicker, RangePicker } = DatePicker
import { setTransDate, setEndDate } from 'core/actions'
import { connect } from 'react-redux'
import { DatePickerContext } from 'context'
import { changePeriodDispatch } from './../../outage-analysis/actions'
const pickerLang = {
  months: [
    'Jan',
    'Feb',
    'Mar',
    'Spr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  from: 'From',
  to: 'To',
}

const _formatYearMonth = ({ year, month }) =>
  fromNullable(year => month => `${pickerLang.months[month - 1]}. ${year}`)
    .ap(fromNullable(year))
    .ap(fromNullable(month))

// const formatYearMonth = ym =>
//   fromNullable(ym)
//     .chain(_formatYearMonth)
//     .getOrElse('?')

const _formatRange = ({ from, to }) =>
  fromNullable(f => t => `${f} ~ ${t}`)
    .ap(fromNullable(from).chain(_formatYearMonth))
    .ap(fromNullable(to).chain(_formatYearMonth))

// const formatRange = range =>
//   fromNullable(range)
//     .chain(_formatRange)
//     .getOrElse('?')

// const currentYear = new Date().getFullYear()

// const rangeBounds = {
//   min: { year: 1971, month: 1 },
//   max: { year: currentYear + 2, month: 1 },
// }

// const DefaultBox = styled.div`
//   border: 1px solid #e0e0e0;
//   background-color: #f6f6f6;
//   padding-left: 0.9rem;
//   padding-right: 0.9rem;
//   box-sizing: border-box;
//   line-height: 3.2rem;
//   font-size: 1.3rem;
//   color: #525252;
//   cursor: pointer;
// `

// const getMoment = from =>
//   moment(
//     from.year +
//       '' +
//       (parseInt(from.month) <= 9 ? '0' + parseInt(from.month) : from.month) +
//       '01'
//   )
// const getMomentFromTo = val => [
//   getMoment(val.from),
//   getMoment(val.to).endOf('month'),
// ]

//   return val
// }

// const convertMoment = aval => {
//   return {
//     from: {
//       year: aval[0].format('YYYY'),
//       month: parseInt(aval[0].format('MM')),
//     },
//     to: { year: aval[1].format('YYYY'), month: parseInt(aval[1].format('MM')) },
//   }
// }

class MonthRange extends React.Component {
  constructor(props) {
    super(props)

    const currentYear = new Date().getFullYear()
    const currrentMonth = new Date().getMonth() + 1
    const defValue = {
      from: { year: currentYear, month: currrentMonth },
      to: { year: currentYear, month: currrentMonth },
    }

    this.state = {
      val: this.props.value || defValue,
    }
    this._onChange = this._onChange.bind(this)
  }

  _onChange(dates) {
    // this.setState(convertMoment(val)
    const val = {
      from: { year: dates[0].format('YYYY'), month: dates[0].format('MM') },
      to: { year: dates[1].format('YYYY'), month: dates[1].format('MM') },
    }
    this.setState(val)
    //  const { setDate, setEndDate } = this.props
    //  setEndDate(getMoment(val.to).endOf('month'))
    //  setDate(getMoment(val.from))
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        val: nextProps.value,
      })
    }
  }

  render() {
    // const { onChange, className, BoxRenderer } = this.props
    // const Box = fromNullable(BoxRenderer).getOrElse(DefaultBox)
    // const { val } = this.state

    return (
      <DatePickerContext.Consumer>
        {({ setSelectedDateRagePicker, selectedDateRangePicker }) => (
          <DatePicker.RangePicker
            allowClear={false}
            mode={['month', 'month']}
            format="MMMM-YYYY"
            value={selectedDateRangePicker}
            placeholder={['Start month', 'End month']}
            onChange={value => {
              setSelectedDateRagePicker([
                value[0].startOf('month'),
                value[1].endOf('month'),
              ])
              this._onChange(value)
            }}
            onPanelChange={value => {
              setSelectedDateRagePicker([
                value[0].startOf('month'),
                value[1].endOf('month'),
              ])
              this.props.changeStoreDates(value)
            }}
          />
        )}
      </DatePickerContext.Consumer>
    )
  }

  // return (
  //   <DatePickerContext.Consumer>
  //     {({ setSelectedDateRagePicker }) => (
  //       <Picker
  //         className={className}
  //         ref={n => (this.picker = n)}
  //         years={rangeBounds}
  //         range={this.state.val}
  //         lang={pickerLang}
  //         theme="light"
  //         onDismiss={
  //           onChange
  //             ? date => {
  //                 // setEndDate(getMoment(date.to).endOf('month'))
  //                 // setDate(getMoment(date.from))
  //                 setSelectedDateRagePicker([
  //                   getMoment(date.from),
  //                   getMoment(date.to).endOf('month'),
  //                 ])
  //                 onChange(date)
  //               }
  //             : this._onChange
  //         }
  //       >
  //         <Box onClick={() => this.picker.show()}>{formatRange(val)}</Box>
  //       </Picker>
  //     )}
  //   </DatePickerContext.Consumer>
  // )
  // return (
  //   <DatePicker.RangePicker
  //     //className={className}
  //     //ref={n => (this.picker = n)}
  //     //years={rangeBounds}
  //     //range={this.state.val}
  //     //lang={pickerLang}
  //     //theme="light"
  //     // onDismiss={onChange || this._onChange}
  //     placeholder={['Start month', 'End month']}
  //     format="MMM.YYYY"
  //     // onChange={onChange ? v => onChange(convertMoment(v)) : this._onChange}
  //     // onPanelChange={
  //     //   onChange ? v => onChange(convertMoment(v)) : this._onChange
  //     // }
  //     value={getMoment(this.state.val || this.props.value)}
  //     mode={['month', 'month']}
  //     allowClear={true}
  //     zIndex={1000}
  //     style={{ zIndex: 1000 }}
  //   >
  //     {/* <Box onClick={() => this.picker.show()}>{formatRange(val)}</Box> */}
  //   </DatePicker.RangePicker>
  // )
}

// export default MonthRange
export default connect(null, {
  setDate: setTransDate,
  setEndDate,
  changeStoreDates: changePeriodDispatch,
})(MonthRange)

const InLineBox = styled.div`
  border: 1px solid #e0e0e0;
  background-color: #f6f6f6;
  padding-left: 0.9rem;
  padding-right: 0.9rem;
  box-sizing: border-box;
  line-height: 2.4rem;
  font-size: 1.3rem;
  color: #525252;
  cursor: pointer;
  border-radius: 0.28571429rem;
  margin-right: 0.9rem;
  margin-left: 0.9rem;
`

const InLineRange = styled(MonthRange)`
  display: inline-block;
`

export const InLineMonthRange = props => (
  <InLineRange {...props} BoxRenderer={InLineBox} />
)
